const keyRows = [
  [
    {
      key: 'Q',
      status: '',
    },
    {
      key: 'W',
      status: '',
    },
    {
      key: 'E',
      status: '',
    },
    {
      key: 'R',
      status: '',
    },
    {
      key: 'T',
      status: '',
    },
    {
      key: 'Y',
      status: '',
    },
    {
      key: 'U',
      status: '',
    },
    {
      key: 'I',
      status: '',
    },
    {
      key: 'O',
      status: '',
    },
    {
      key: 'P',
      status: '',
    },
  ],
  [
    {
      key: 'A',
      status: '',
    },
    {
      key: 'S',
      status: '',
    },
    {
      key: 'D',
      status: '',
    },
    {
      key: 'F',
      status: '',
    },
    {
      key: 'G',
      status: '',
    },
    {
      key: 'H',
      status: '',
    },
    {
      key: 'J',
      status: '',
    },
    {
      key: 'K',
      status: '',
    },
    {
      key: 'L',
      status: '',
    },
  ],
  [
    {
      key: 'ENTER',
      status: '',
    },
    {
      key: 'Z',
      status: '',
    },
    {
      key: 'X',
      status: '',
    },
    {
      key: 'C',
      status: '',
    },
    {
      key: 'V',
      status: '',
    },
    {
      key: 'B',
      status: '',
    },
    {
      key: 'N',
      status: '',
    },
    {
      key: 'M',
      status: '',
    },
    {
      key: '\u232b',
      status: '',
    },
  ],
]

export default keyRows
